import classNames from 'classnames';
import { FC } from 'react';

export interface ITariffCardLabelProps {
  //   bgColor: string;
  //   textColor?: string;
  title: string;
  className?: string;
}
export const TariffCardLabel: FC<ITariffCardLabelProps> = ({ className, title }) => {
  return (
    <div
      className={classNames('h-full w-full', className)}
      style={{
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%)',
      }}
    >
      <p className={'text-center text-ui-xs-strong pt-2'}>{title}</p>
    </div>
  );
};
